<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>Onboarding Stages</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <fieldset style="border: 0;"
      [disabled]="crewChange?.isCancelled || !hasRole('vessels-crew-change-editor')">

      @if (organisations) {
      <div>
        @for (item of items; track $index; let i = $index) {
        <div class="mb-3">
          <div class="row align-items-center">
            <div class="col-md-6">
              <app-material-organisation-selector
                id="{{ item.plan + 'place' }}"
                class="pg-component"
                [placeholder]=" item.plan "
                [ngModel]="plannedPlaces[i]"
                (ngModelChange)="setChangePlanPlace(item, $event, i)"
                [organisationLanguage]="'en'"
                name="{{ item.plan + 'place' }}"
                [organisations]="places"
                [disabled]="(i !== (items.length - 1))"
                [required]="true">
              </app-material-organisation-selector>
            </div>
            <div class="col-md-6">
              <app-material-date-time-zone
                type="date"
                name="{{ item.plan + 'time' }}"
                id="{{ item.plan + 'time' }}"
                [ngModel]="plannedTimes[i]"
                (ngModelChange)="setChangePlanTime(item, $event, i)"
                label="{{ item.plan + 'time' }}"
                [disabled]="(i !== (items.length - 1) || !item.place)">
              </app-material-date-time-zone>
            </div>
          </div>
        </div>
        }
      </div>
      }

      <div class="text-end mt-3">
        @if (hasRole('vessels-crew-change-editor') && crewChange?.isCancelled === false) {
        <app-material-pg-button
          (clicked)="save()"
          [disabled]="disabled"
          label="Save">
        </app-material-pg-button>
        }

        @if (hasRole('vessels-crew-change-editor') && crewChange?.isCancelled === false) {
        <app-material-pg-button
          class="pull-right me-1"
          (clicked)="removeLastPlan()"
          [disabled]="crewChange.item.length === 0"
          label="Remove Last">
        </app-material-pg-button>
        }

        @if (hasRole('vessels-crew-change-editor') && crewChange?.isCancelled === false) {
        <app-material-pg-button
          class="pull-right me-1"
          (clicked)="addPlan()"
          [disabled]="disabled || items.length === 4 "
          label="Add Plan">
        </app-material-pg-button>
        }

      </div>
    </fieldset>
  </mat-card-content>
</mat-card>